import React, { useEffect, useState } from "react";
import arrowRight from "../../../../assets/arrow-right.png";
import accessoriesIcon from "../../../../assets/u400c/accessories.png";
import comboIcon from "../../../../assets/u400c/combo.png";
import arrowDown from "../../../../assets/arrow-down.png";
import arrowUp from "../../../../assets/arrow-up.png";
import MenuKit from "../menuKit";
import MenuItem from "../menuItem/index.js";
import { useSelector } from "react-redux";
import { setCustomConfigData } from "../../../../redux/actions/custom-config-data-action";
import { useDispatch } from "react-redux";
import "./menu.css";
import ComponentLoader from "../../../../components/componentLoader";
import RaceNumModal from "../raceNumber";
import { setCustomCompId } from "../../../../redux/actions/custom-comp-id-action";
import axios from "axios";
import styleIcon from "../../../../assets/u400c/style.png";
import utilityIcon from "../../../../assets/u400c/utility.png";
import safetyIcon from "../../../../assets/u400c/safety.png";
import touringIcon from "../../../../assets/u400c/touring.png";
import styleComboIcon from "../../../../assets/u400c/styling_pack.png";
import utilityComboIcon from "../../../../assets/u400c/utility_pack.png";
import safetyComboIcon from "../../../../assets/u400c/safety_pack.png";
import touringComboIcon from "../../../../assets/u400c/touring_pack.png";
import { ConfigBaseUrl, VehicleCode } from "../../../../config";

const Menu = ({
  onDrawer,
  warningMessage,
  cartWarningModal,
  enableResetButton,
  crossSellMessage,
  crossSellImg,
}) => {
  const [accessoriesExpand, setAccessoriesExpand] = useState(false);
  const [safety, setSafety] = useState(false);
  const [toggleArrow, setToggleArrow] = useState(false);
  const [accessoriesData, setAccessoriesData] = useState([]);
  const [comboPackData, setComboPackData] = useState([]);
  const [indexVal, setIndexVal] = useState();
  const [raceNumModal, setRaceNumModal] = useState(false);
  const [comboExpand, setComboExpand] = useState(false);
  const [comboPackTitle, setComboPackTitle] = useState("");
  const [accessoriesTitle, setAccessoriesTitle] = useState("");
  const [loader, setLoader] = useState(false);

  const customConfigData = useSelector((state) => state.customConfigData.data);

  const dispatch = useDispatch();

  useEffect(() => {
    try {
      setLoader(true);

      if (customConfigData?.accessoriesData) {
        setAccessoriesData(customConfigData?.accessoriesData);
        setComboPackData(customConfigData?.comboPack);
        setComboPackTitle(customConfigData?.comboPack[0]?.Catogery);
        setAccessoriesTitle(customConfigData?.accessoriesData[0]?.Catogery);
        setLoader(false);
      } else {
        axios({
          method: "post",
          url: ConfigBaseUrl() + "accessoriesUat",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {
            categoryType: ["accessories"],
            categoryCode: [],
            genderfacet: [],
            segment: [],
            colorfacet: "",
            vehicleCode: VehicleCode,
            pageNumber: 0,
            pageSize: 100,
          },
        }).then((res) => {
          const data = res.data;
          if (data?.status === "success") {
            const accessoriesArrData = data?.data?.filter(
              (el) =>
                el.Catogery === "Accessories" || el.Catogery === "Combo Pack"
            );

            let ans = accessoriesArrData?.reduce((agg, curr) => {
              let found = agg.find(
                (x) => x.ProductCatogery === curr.ProductCatogery
              );
              if (found) {
                found.data.push(curr);
              } else {
                agg.push({
                  ProductCatogery: curr.ProductCatogery,
                  Catogery: curr.Catogery,
                  data: [curr],
                });
              }
              return agg;
            }, []);

            const modifiedData = ans?.map((el) => {
              el.ProductCatogery === "Style" && (el.image = styleIcon);

              el.ProductCatogery === "Utility" && (el.image = utilityIcon);

              el.ProductCatogery === "Safety" && (el.image = safetyIcon);

              el.ProductCatogery === "Touring" && (el.image = touringIcon);

              el.ProductCatogery === "SAFETY Combo Pack" &&
                (el.image = safetyComboIcon);

              el.ProductCatogery === "STYLING Combo Pack" &&
                (el.image = styleComboIcon);

              el.ProductCatogery === "TOURING Combo Pack" &&
                (el.image = touringComboIcon);

              el.ProductCatogery === "UTILITY Combo Pack" &&
                (el.image = utilityComboIcon);

              return el;
            });

            const accessories = modifiedData.filter(
              (el) => el.Catogery == "Accessories"
            );

            customConfigData["accessoriesData"] = accessories;

            const combopack = modifiedData.filter(
              (el) => el.Catogery == "Combo Pack"
            );

            customConfigData["comboPack"] = combopack;

            setAccessoriesData(accessories);
            setComboPackData(combopack);
            setComboPackTitle(combopack[0]?.Catogery);
            setAccessoriesTitle(accessories[0]?.Catogery);
            dispatch(setCustomConfigData(structuredClone(customConfigData)));
            setLoader(false);
          } else {
            setLoader(false);
          }
        });
      }
    } catch (error) {
      setLoader(false);
    } finally {
    }
  }, [customConfigData]);

  const onDrawerClose = () => {
    setSafety(false);
  };

  const onAddAccessories = (name, productCode, price, catogery) => {
    const hasProductId = customConfigData?.orderDetails?.some(
      (item) => item.ProductId === productCode
    );
    enableResetButton(true);

    if (!hasProductId) {
      customConfigData?.orderDetails.push({
        ProductName: name,
        ProductId: productCode,
        Quantity: 1,
        Colour: "",
        Price: price,
        Type: catogery,
      });
    }
  };

  const onDeleteAccessories = (partNumber) => {
    const hasProductId = customConfigData?.orderDetails?.some(
      (item) => item.ProductId === partNumber
    );

    const merchandiseCartStatus = customConfigData?.merchandise?.some(
      (element) => {
        return element["cartStatus"] === true;
      }
    );

    const combopackCartStatus = customConfigData?.comboPack?.some((element) => {
      return element?.data?.some((elem) => {
        return elem["cartStatus"] === true;
      });
    });

    const accessoriesCartStatus = customConfigData?.accessoriesData?.some(
      (element) => {
        return element?.data?.some((elem) => {
          return elem["cartStatus"] === true;
        });
      }
    );

    const kitStatus = customConfigData?.kits?.some((item) => {
      return item["status"] === true;
    });

    if (
      merchandiseCartStatus ||
      combopackCartStatus ||
      accessoriesCartStatus ||
      kitStatus
    ) {
      enableResetButton(true);
    } else {
      enableResetButton(false);
    }

    if (hasProductId) {
      customConfigData.orderDetails.splice(
        customConfigData.orderDetails.findIndex(
          (item) => item.ProductId === partNumber
        ),
        1
      );
    }
  };

  /************************ Add Cart Warning Modal Start ************************/
  const onAddCartWarning = (partNumber) => {
    let selectedNames = [];
    const DispatchArr = [];

    const hasKitStatus = customConfigData?.businessRules?.some(
      (el) =>
        el.type === "BlockDependence" &&
        el.dependent.partNumber === partNumber &&
        el.selected.partNumber ===
          customConfigData?.kits?.find(
            (element) =>
              element?.status === true && element.id === el.selected.partNumber
          )?.id
    );

    customConfigData?.businessRules?.forEach((el) => {
      if (
        el.type === "BlockDependence" &&
        el.dependent.partNumber === partNumber
      ) {
        /////////////////////////accessories-combo/////////////////////////
        if (!hasKitStatus) {
          customConfigData?.accessoriesData?.map((element) => {
            element?.data?.map((e) => {
              if (
                e.ProductCode === el.selected.partNumber &&
                e.cartStatus === true
              ) {
                selectedNames.push(e.Name);

                warningMessage(
                  `The ${el.dependent.name} is part of the ${selectedNames
                    ?.toString()
                    .replace(/,/g, ", ")}. To add only the ${
                    el.dependent.name
                  }, please remove the ${selectedNames
                    ?.toString()
                    .replace(/,/g, ", ")} from your cart.`
                );
                cartWarningModal(true);
                //

                customConfigData?.accessoriesData?.map((element) => {
                  element?.data?.map((r) => {
                    if (r.ProductCode === e.ProductCode) {
                      r.cartStatus = false;
                    }
                  });
                });
                onDeleteAccessories(e.ProductCode.toLowerCase());

                const hasId = [...DispatchArr]?.some(
                  (item) => item.id === e.ProductCode
                );
                if (!hasId) {
                  DispatchArr.push({
                    id: e.ProductCode,
                    status: false,
                  });
                }

                customConfigData?.comboPack?.map((element) => {
                  element?.data?.map((ele) => {
                    if (ele.ProductCode === el.dependent.partNumber) {
                      ele.disable = false;
                      // ele.cartStatus = false;
                      onCart(
                        ele?.Name,
                        ele?.Price,
                        ele?.ProductCode,
                        ele?.Catogery,
                        "",
                        "",
                        true
                      );
                    }
                  });
                });

                //
              }
            });
          });
        }
        ////////////////////////////////////////////////////////////////

        //////////////////////combo-acc/////////////////////////////////
        customConfigData?.comboPack?.map((element) => {
          element?.data.map((e) => {
            if (
              e.ProductCode === el.selected.partNumber &&
              e.cartStatus === true
            ) {
              selectedNames.push(e.Name);

              warningMessage(
                `The ${el.dependent.name} is part of the ${selectedNames
                  ?.toString()
                  .replace(/,/g, ", ")}. To add only the ${
                  el.dependent.name
                }, please remove the ${selectedNames
                  ?.toString()
                  .replace(/,/g, ", ")} from your cart.`
              );
              cartWarningModal(true);
            }
          });
        });
        ////////////////////////////////////////////////////////////

        /////////////////kit-acc and kit-combo/////////////////////
        customConfigData?.kits?.map((element) => {
          if (
            element?.status === true &&
            element.id === el.selected.partNumber
          ) {
            selectedNames.push(element?.name);

            warningMessage(
              `The ${el.dependent.name} is part of the ${selectedNames
                ?.toString()
                .replace(/,/g, ", ")}. To add only the ${
                el.dependent.name
              }, please remove the ${selectedNames
                ?.toString()
                .replace(/,/g, ", ")} from your cart.`
            );
            cartWarningModal(true);
          }
        });
        //////////////////////////////////////////////////////////
      }
    });
  };

  /************************ Add Cart Warning Modal End ************************/

  const onCart = (
    name,
    price,
    partNumber,
    category,
    AccessoriesIndex,
    PartNumIndex,
    status
  ) => {
    customConfigData?.accessoriesData?.map((element) => {
      element?.data?.map((r) => {
        if (r.ProductCode === partNumber) {
          r.cartStatus = status;
        }
      });
    });
    customConfigData?.comboPack?.map((element) => {
      element?.data?.map((r) => {
        if (r.ProductCode === partNumber) {
          r.cartStatus = status;
        }
      });
    });

    /////////////////

    // setAdd(!add);

    const DispatchArr = [];
    //add-delete single acc
    /* ******************   start   **************** */
    if (status) {
      onAddAccessories(name, partNumber.toLowerCase(), price, category);

      const hasId = [...DispatchArr]?.some((item) => item.id === partNumber);
      if (!hasId) {
        DispatchArr.push({
          id: partNumber,
          status: status,
        });
      }
    } else {
      onDeleteAccessories(partNumber.toLowerCase());

      const hasId = [...DispatchArr]?.some((item) => item.id === partNumber);
      if (!hasId) {
        DispatchArr.push({
          id: partNumber,
          status: status,
        });
      }
    }
    /* ******************   end   **************** */

    customConfigData?.businessRules?.filter((el) => {
      // auto add acc
      /* ******************   start   **************** */
      if (
        el.type === "AutoAdd" &&
        el.selected.partNumber === partNumber &&
        status === true
      ) {
        const selectedAccessories = customConfigData?.accessoriesData?.map(
          (element) =>
            element?.data?.find((r) => r.ProductCode === el.selected.partNumber)
        );

        const firstNonNullAccessory = selectedAccessories.filter(
          (accessory) => accessory !== undefined
        )[0];

        customConfigData?.accessoriesData?.map((element) => {
          element?.data?.map((r) => {
            if (r.ProductCode === el.selected.partNumber) {
              r.cartStatus = status;

              onAddAccessories(
                r?.Name,
                r?.ProductCode.toLowerCase(),
                r?.Price,
                r?.Catogery
              );

              const hasId = [...DispatchArr]?.some(
                (item) => item.id === el.selected.partNumber
              );
              if (!hasId) {
                DispatchArr.push({
                  id: el.selected.partNumber,
                  status: status,
                });
              }
            }
            if (
              r.ProductCode === el.dependent.partNumber &&
              r.cartStatus === false
            ) {
              r.cartStatus = status;

              onAddAccessories(
                r?.Name,
                r?.ProductCode.toLowerCase(),
                r?.Price,
                r?.Catogery
              );

              //Mandatory Popup add here

              crossSellMessage(
                `Added ${r?.Name} , as it's mandatory, along with ${firstNonNullAccessory?.Name}. `
              );
              crossSellImg(r?.Images[0]);
              cartWarningModal(true);

              ///////////

              const hasId = [...DispatchArr]?.some(
                (item) => item.id === el.dependent.partNumber
              );
              if (!hasId) {
                DispatchArr.push({
                  id: el.dependent.partNumber,
                  status: status,
                });
              }
            }
          });
        });
      }
      /* ******************   end   **************** */

      // auto delete acc
      /* ******************   start   **************** */
      if (
        el.type === "AutoDelete" &&
        el.selected.partNumber === partNumber &&
        status === false
      ) {
        customConfigData?.accessoriesData?.map((element) => {
          element?.data?.map((r) => {
            if (r.ProductCode === el.selected.partNumber) {
              r.cartStatus = status;
              onDeleteAccessories(el.selected.partNumber.toLowerCase());

              const hasId = [...DispatchArr]?.some(
                (item) => item.id === el.selected.partNumber
              );
              if (!hasId) {
                DispatchArr.push({
                  id: el.selected.partNumber,
                  status: status,
                });
              }
            }
            if (r.ProductCode === el.dependent.partNumber) {
              r.cartStatus = status;
              onDeleteAccessories(el.dependent.partNumber.toLowerCase());
              const hasId = [...DispatchArr]?.some(
                (item) => item.id === el.dependent.partNumber
              );
              if (!hasId) {
                DispatchArr.push({
                  id: el.dependent.partNumber,
                  status: status,
                });
              }
            }
          });
        });
      }
      /* ******************   end   **************** */

      // block-dependency acc/combo - kits
      /* ******************   start   **************** */
      if (
        el.type === "BlockDependence" &&
        el.selected.partNumber === partNumber
      ) {
        customConfigData?.kits?.map((r) => {
          if (r.id === el.dependent.partNumber) {
            r.disable = status;
          }
        });
      }
      /* ******************   end   **************** */

      // block-dependency  acc - combo
      /* ******************   start   **************** */
      if (
        el.type === "BlockDependence" &&
        el.selected.partNumber === partNumber
      ) {
        customConfigData?.comboPack?.map((x) => {
          x?.data?.map((y) => {
            if (y.ProductCode === el.dependent.partNumber) {
              y.disable = status;

              if (status === false) {
                customConfigData?.businessRules?.map((elements) => {
                  if (elements.dependent.partNumber === y.ProductCode) {
                    customConfigData?.kits?.some((rel) => {
                      if (
                        rel.id === elements.selected.partNumber &&
                        rel?.status === true
                      ) {
                        y.disable = true;
                      }
                    });
                  }
                });
              }
            }
          });
        });
      }
      /* ******************   end   **************** */

      // block-dependency combo - acc
      /* ******************   start   **************** */
      if (
        el.type === "BlockDependence" &&
        el.selected.partNumber === partNumber
      ) {
        customConfigData?.accessoriesData?.map((x) => {
          x?.data?.map((y) => {
            if (y.ProductCode === el.dependent.partNumber) {
              y.disable = status;
            }
          });
        });
      }

      /* ******************   end   **************** */

      // Crossselling acc - acc
      /* ******************   start   **************** */

      if (
        el.type === "Crossselling" &&
        el.selected.partNumber === partNumber &&
        status === true
      ) {
        customConfigData?.accessoriesData?.map((x) => {
          x?.data?.map((y) => {
            if (
              y.ProductCode === el.dependent.partNumber &&
              y?.cartStatus !== true
            ) {
              //Crossselling Popup add here

              crossSellMessage(
                `People also buy ${y?.Name} along with  ${el.selected.name}. `
              );
              crossSellImg(y?.Images[0]);
              cartWarningModal(true);
            }
          });
        });
      }

      /* ******************   end   **************** */
    });

    dispatch(setCustomCompId(DispatchArr));

    if (
      (partNumber === "N7224580" ||
        partNumber === "N7320940" ||
        partNumber === "N7321020") &&
      status === true
    ) {
      setRaceNumModal(status);
    }

    dispatch(setCustomConfigData(structuredClone(customConfigData)));
  };

  return (
    <>
      {raceNumModal && (
        <div
          className="tooltip-bg"
          style={{
            display: " flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 1,
            zIndex: 5,
            overflowY: "scroll",
            width: "100%",
            height: "100%",
          }}
        >
          <RaceNumModal
            onRaceNumModal={setRaceNumModal}
            raceNumModal={raceNumModal}
          />
        </div>
      )}
      <div className="drawer-modal">
        <div className="drawer-container">
          <div
            className="nav-close"
            onClick={() => {
              onDrawer();
              onDrawerClose();
            }}
          >
            <img className="nav-close-icon" src={arrowRight} />
          </div>

          {(accessoriesData?.length === 0 &&
            comboPackData?.length === 0 &&
            comboPackTitle === "" &&
            accessoriesTitle === "") ||
          loader ? (
            <ComponentLoader color={"#FFE100"} />
          ) : (
            <>
              <div className="config-category">
                <MenuItem
                  image={comboIcon}
                  label={comboPackTitle}
                  // desc={"Lorem ipsum dolor sit amet, consectetur"}
                  arrowIcon={comboExpand ? arrowUp : arrowDown}
                  onClick={() => {
                    setComboExpand(!comboExpand);
                    setAccessoriesExpand(false);
                    setSafety(false);
                    setIndexVal("");
                  }}
                />

                {comboExpand &&
                  comboPackData?.map((item, index) => (
                    <>
                      <div className="acc-line"></div>
                      <MenuItem
                        image={item?.image}
                        label={item?.ProductCatogery}
                        desc={item?.Description}
                        arrowIcon={
                          indexVal === index && toggleArrow
                            ? arrowUp
                            : arrowDown
                        }
                        onClick={() => {
                          setToggleArrow(
                            indexVal === index && toggleArrow ? false : true
                          );
                          setIndexVal(index);
                        }}
                      />

                      {indexVal === index && toggleArrow && (
                        <>
                          {item.data.map((r, i) => (
                            <>
                              <div className="nested-line"></div>
                              <MenuKit
                                data={r}
                                AccessoriesIndex={index}
                                PartNumIndex={i}
                                onCart={onCart}
                                add={r?.cartStatus}
                                onAddCartWarning={onAddCartWarning}
                              />
                            </>
                          ))}
                        </>
                      )}
                    </>
                  ))}
              </div>

              <div className="config-category">
                <MenuItem
                  image={accessoriesIcon}
                  label={accessoriesTitle}
                  // desc={"Lorem ipsum dolor sit amet, consectetur"}
                  arrowIcon={accessoriesExpand ? arrowUp : arrowDown}
                  onClick={() => {
                    setAccessoriesExpand(!accessoriesExpand);
                    setComboExpand(false);
                    setSafety(false);
                    setIndexVal("");
                  }}
                />

                {accessoriesExpand &&
                  accessoriesData?.map((item, index) => (
                    <>
                      <div className="acc-line"></div>
                      <MenuItem
                        image={item?.image}
                        label={item?.ProductCatogery}
                        desc={item?.Description}
                        arrowIcon={
                          indexVal === index && toggleArrow
                            ? arrowUp
                            : arrowDown
                        }
                        onClick={() => {
                          // onArrow(index, item?.partNumbers);
                          setToggleArrow(
                            indexVal === index && toggleArrow ? false : true
                          );
                          setIndexVal(index);
                        }}
                      />

                      {indexVal === index && toggleArrow && (
                        <>
                          {item.data.map((r, i) => (
                            <>
                              <div className="nested-line"></div>
                              <MenuKit
                                data={r}
                                AccessoriesIndex={index}
                                PartNumIndex={i}
                                onCart={onCart}
                                add={r?.cartStatus}
                                onAddCartWarning={onAddCartWarning}
                              />
                            </>
                          ))}
                        </>
                      )}
                    </>
                  ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Menu;
